import { render, staticRenderFns } from "./result-pay.vue?vue&type=template&id=f6d4141a&"
import script from "./result-pay.vue?vue&type=script&lang=js&"
export * from "./result-pay.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports